import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { VendorModule } from '../../vendor.module';
import {
  AvanoErrorPageComponent,
  ChartComponent,
  MultiInputComponent,
  RecentSearchesComponent,
  ScipTableFilterComponent,
  ScipTableFilterResetAllComponent,
  ScipTableFilterService,
  SearchContainerComponent,
  TwinTableSelectComponent
} from './components';
import {
  ArticleCategorySelectDialogComponent,
  ArticleCategoryTreeComponent,
  DashboardUserSettingsComponent,
  DossierErrorDetailsDialogComponent,
  DownloadDialogComponent,
  MaterialSelectionDialogComponent,
  MixtureSelectionDialogComponent,
  OtherArticleIdentifierDialogComponent,
  OtherNameDialogComponent
} from './dialogs';
import {
  PasswordToggleDirective,
  RequiresFeatureDirective,
  S2sKeyValidatorDirective,
  SelectFieldMultipleDirective,
  SpacesAsIsDirective,
  SubmissionStatusDirective,
  UiSettingsDirective,
  WhitespaceValidatorDirective
} from './directives';
import {
  ArticleCategoryChipPipe,
  CanDownloadDossierPipe,
  CategoryNamePipe,
  DossierPlaceholderPipe,
  DossierStateTranslationKeyPipe,
  ProductionInEUTranslationKeyPipe,
  IsInDownloadPipe,
  MaterialCategoryChipPipe,
  MixtureCategoryChipPipe,
  NestedPropertyPipe,
  OtherArticleIdentifierLabelPipe,
  OtherArticleIdentifierPipe,
  OtherNameLabelPipe,
  RecentSearchTypePipe,
  ValueFromFiltermetadataPipe
} from './pipes';

const components = [
  ChartComponent,
  RecentSearchesComponent,
  SearchContainerComponent,
  TwinTableSelectComponent,
  AvanoErrorPageComponent,
  MultiInputComponent,
  ScipTableFilterComponent,
  ScipTableFilterResetAllComponent
];

const dialogs = [
  ArticleCategorySelectDialogComponent,
  ArticleCategoryTreeComponent,
  DashboardUserSettingsComponent,
  DossierErrorDetailsDialogComponent,
  DownloadDialogComponent,
  MaterialSelectionDialogComponent,
  MixtureSelectionDialogComponent,
  OtherArticleIdentifierDialogComponent,
  OtherNameDialogComponent
];

const directives = [
  PasswordToggleDirective,
  RequiresFeatureDirective,
  SubmissionStatusDirective,
  WhitespaceValidatorDirective,
  SelectFieldMultipleDirective,
  SpacesAsIsDirective,
  S2sKeyValidatorDirective,
  UiSettingsDirective
];

const pipes = [
  ArticleCategoryChipPipe,
  CategoryNamePipe,
  CanDownloadDossierPipe,
  DossierPlaceholderPipe,
  DossierStateTranslationKeyPipe,
  ProductionInEUTranslationKeyPipe,
  RecentSearchTypePipe,
  IsInDownloadPipe,
  MaterialCategoryChipPipe,
  MixtureCategoryChipPipe,
  NestedPropertyPipe,
  OtherArticleIdentifierLabelPipe,
  OtherArticleIdentifierPipe,
  OtherNameLabelPipe,
  ValueFromFiltermetadataPipe
];

const modules = [CommonModule, VendorModule];

const services = [ScipTableFilterService];

@NgModule({
  declarations: [...components, ...dialogs, ...directives, ...pipes],
  imports: [...modules, ReactiveFormsModule, TranslateModule],
  providers: [...services],
  exports: [...components, ...dialogs, ...directives, ...pipes, ...modules]
})
export class SharedModule {}
